import gsap from 'gsap/all'
import Component from '../classes/Component'

export default class extends Component {
  constructor (element, elements, direction = 'left', duration = 10, pauseOnHover = false) {
    super({
      classes: {},
      element: element,
      elements: {
        inner: (elements && elements.inner) || '[data-scrolling-marquee-inner]',
        row: (elements && elements.row) || '[data-scrolling-marquee-row]',
        items: (elements && elements.items) || '[data-scrolling-marquee-item]'
      }
    })

    this.direction = direction
    this.isLeft = direction === 'left'
    this.duration = duration
    this.pauseOnHover = pauseOnHover

    this.create()
  }

  createStyles () {
    if (this.isLeft) {
      gsap.set(this.element, {
        left: 0
      })
    } else {
      gsap.set(this.element, {
        right: 0
      })
    }
    gsap.set(this.element, {
      position: 'absolute',
      overflow: 'hidden'
    })
    gsap.set(this.elements.inner, {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      flexGrow: 0
    })
    gsap.set(this.elements.row, {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      flexGrow: 0
    })
    gsap.set(this.elements.items, {
      flexShrink: 0,
      flexGrow: 0
    })
  }

  create () {
    this.createStyles()

    this.elements.inner.appendChild(this.elements.row.cloneNode(true))
    this.tween = gsap
      .to(this.elements.inner, {
        x: this.isLeft ? '-50%' : '50%',
        ease: 'none',
        duration: this.duration,
        repeat: -1
      })

    if (this.pauseOnHover) {
      this.element.addEventListener('mouseenter', () => {
        this.tween.pause()
      })
      this.element.addEventListener('mouseleave', () => {
        this.tween.play()
      })
    }
  }
}
